<div class="page-body mt-3">

  @if (isLoading) {
    <div class="container container-slim py-4">
      <div class="text-center">
        <div class="mb-3">
        </div>
        <div class="text-muted mb-3">Lade Daten</div>
        <div class="progress progress-sm">
          <div class="progress-bar progress-bar-indeterminate"></div>
        </div>
      </div>
    </div>
  }

  @if (!isLoading) {
    <div class="container-fluid">
      @if (ticket !== undefined && ticket.created_for_user) {
        <div class="row">
          <div class="col-12">
            <div class="alert alert-primary">Dieses Anliegen wurde vom EFS-IT-Support nach Ihrer Kontaktaufnahme für
            Sie im EFSsupport System erstellt.</div>
          </div>
        </div>
      }
      @if (ticket !== undefined) {
        <div class="row row-deck row-cards">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                @if (ticket !== undefined) {
                  <div class="row w-100">
                    <div class="col-lg-8 mt-0">
                      @if (ticket !== undefined) {
                        <h2 class="page-title">
                          <span class="text-muted me-1">#{{ ticket.ticket_number }}</span> - <span
                        class="ms-1">{{ ticket.subject }}</span>
                      </h2>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="card-body">
              <div class="datagrid">
                <div class="datagrid-item">
                  <div class="datagrid-title">Anfragennummer</div>
                  <div class="datagrid-content">#{{ ticket.ticket_number }}</div>
                </div>
                <div class="datagrid-item">
                  <div class="datagrid-title">Status</div>
                  <div class="datagrid-content">
                    @if (ticket.status === 'open') {
                      <span class="status status-green">Offen</span>
                    }
                    @if (ticket.status === 'closed') {
                      <span
                      class="status status-secondary">Geschlossen</span>
                    }
                    @if (ticket.status === 'answered') {
                      <span
                      class="status status-success">Beantwortet</span>
                    }
                    @if (ticket.status === 'in_progress') {
                      <span class="status status-success">In
                      Bearbeitung</span>
                    }
                    @if (ticket.status === 'awaiting_external_feedback') {
                      <span
                      class="status status-warning">Externe Rückmeldung ausstehend</span>
                    }
                    @if (ticket.status === 'more_information_needed') {
                      <span
                      class="status status-warning">Weitere Informationen benötigt</span>
                    }
                  </div>
                </div>
                @if (!ticket.created_for_user) {
                  <div class="datagrid-item">
                    <div class="datagrid-title">Erstellt von</div>
                    @if (ticket.author_user_sso_id) {
                      <div class="datagrid-content ">
                        <span>{{ ticket.author_name }}</span>
                        <br>
                          @if (ticket.author_email) {
                            <span class="text-muted">{{ ticket.author_email
                              }}<br></span>
                            }
                            @if (ticket.author_user_sso_id) {
                              <span class="text-muted"
                              >{{ticket.author_user_sso_id }}</span>
                            }
                          </div>
                        }
                        @if (!ticket.author_user_sso_id) {
                          <div class="datagrid-content">
                            {{ ticket.author_name }}<br>
                            @if (ticket.author_email) {
                              <span class="text-muted">{{ ticket.author_email
                                }}<br></span>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (ticket.created_for_user) {
                        <div class="datagrid-item">
                          <div class="datagrid-title">Erstellt von</div>
                          @if (ticket.created_for_user_cn) {
                            <div class="datagrid-content ">
                              <span>{{ ticket.created_for_user_name }}</span>
                              <br>
                                @if (ticket.created_for_user_mail) {
                                  <span class="text-muted">{{
                                    ticket.created_for_user_mail
                                    }}<br></span>
                                  }
                                  @if (ticket.created_for_user_cn) {
                                    <span class="text-muted"
                                    >{{ticket.created_for_user_cn }}</span>
                                  }
                                </div>
                              }
                              @if (!ticket.created_for_user_cn) {
                                <div class="datagrid-content">
                                  {{ ticket.created_for_user_name }}<br>
                                  @if (ticket.created_for_user_mail) {
                                    <span class="text-muted">{{
                                      ticket.created_for_user_mail
                                      }}<br></span>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (ticket.created_for_user) {
                              <div class="datagrid-item">
                                <div class="datagrid-title">Erstellt für</div>
                                @if (ticket.author_user_sso_id) {
                                  <div class="datagrid-content ">
                                    <span>{{ ticket.author_name }}</span>
                                    <br>
                                      @if (ticket.author_email) {
                                        <span class="text-muted">{{ ticket.author_email
                                          }}<br></span>
                                        }
                                        @if (ticket.author_user_sso_id) {
                                          <span class="text-muted"
                                          >{{ticket.author_user_sso_id }}</span>
                                        }
                                      </div>
                                    }
                                    @if (!ticket.author_user_sso_id) {
                                      <div class="datagrid-content">
                                        {{ ticket.author_name }}<br>
                                        @if (ticket.author_email) {
                                          <span class="text-muted">{{ ticket.author_email
                                            }}<br></span>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                  <div class="datagrid-item">
                                    <div class="datagrid-title">Quelle</div>
                                    <div class="datagrid-content">
                                      @if (ticket.source === 'mail') {
                                        <span>E-Mail</span>
                                      }
                                      @if (ticket.source === 'landingpage') {
                                        <span>EFSsupport System</span>
                                      }
                                    </div>
                                  </div>
                                  <div class="datagrid-item">
                                    <div class="datagrid-title">Anliegen Typ</div>
                                    @if (ticket.type === 'support_request') {
                                      <div class="datagrid-content">
                                      Support-Anfrage</div>
                                    }
                                    @if (ticket.type === 'bug_report') {
                                      <div class="datagrid-content">Bug-Report
                                      </div>
                                    }
                                    @if (ticket.type === 'feature_request') {
                                      <div class="datagrid-content">
                                      Feature-Wunsch</div>
                                    }
                                    @if (ticket.type === 'tom') {
                                      <div class="datagrid-content">TOM</div>
                                    }
                                  </div>
                                  @if (ticket.created_at) {
                                    <div class="datagrid-item">
                                      <div class="datagrid-title">Erstellt am</div>
                                      <div class="datagrid-content">{{ ticket.created_at | date: 'dd.MM.yyyy HH:mm' }}</div>
                                    </div>
                                  }
                                  @if (ticket.first_answer_at) {
                                    <div class="datagrid-item">
                                      <div class="datagrid-title">Erste Antwort</div>
                                      <div class="datagrid-content">{{ ticket.first_answer_at | date: 'dd.MM.yyyy HH:mm' }}
                                      </div>
                                    </div>
                                  }
                                  @if (ticket.last_answer_at) {
                                    <div class="datagrid-item">
                                      <div class="datagrid-title">Neueste Antwort</div>
                                      <div class="datagrid-content">{{ ticket.last_answer_at | date: 'dd.MM.yyyy HH:mm' }}
                                      </div>
                                    </div>
                                  }
                                  @if (ticket.resolved_at) {
                                    <div class="datagrid-item">
                                      <div class="datagrid-title">Anliegen erledigt</div>
                                      <div class="datagrid-content">{{ ticket.resolved_at | date: 'dd.MM.yyyy HH:mm' }}</div>
                                    </div>
                                  }
                                  @if (ticket.escalated_at) {
                                    <div class="datagrid-item">
                                      <div class="datagrid-title">Anliegen eskaliert</div>
                                      <div class="datagrid-content">{{ ticket.escalated_at | date: 'dd.MM.yyyy HH:mm' }}</div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          @for (answer of ticketAnswers; track answer) {
                            <div class="col-lg-12">
                              <!-- Initial Data submittet over the ticket system -->
                              @if (answer.type === 'auditAnswer' &&  answer.audit_answer_type === 'ticketStatusUpdate' && answer.audit_visible_in_ticket) {
                                <div class="card"
                                  >
                                  <div class="card-status-start bg-primary"></div>
                                  <div class="card-header card-small">
                                    <h3 class="card-title">Statusänderung</h3>
                                  </div>
                                  <div class="card-body">
                                    {{ answer.text }}
                                  </div>
                                </div>
                              }
                              <!-- Customer Answers -->
                              @if (answer.type === 'customerAnswer' || answer.type === 'supportAnswer') {
                                <div class="card">
                                  <div class="card-header card-small">
                                    @if (answer.created_for_user) {
                                      <span class="me-1 badge badge-warning"
                                        [ngbTooltip]="'Diese Antwort wurde vom EFS-IT-Support erstellt'">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-user-shield"
                                          width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                                          fill="none" stroke-linecap="round" stroke-linejoin="round">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                          <path d="M6 21v-2a4 4 0 0 1 4 -4h2"></path>
                                          <path
                                            d="M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z">
                                          </path>
                                          <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                                        </svg>
                                      </span>
                                    }
                                    <strong class="me-1">{{ answer.author_name }}</strong> @if (answer.type === 'supportAnswer') {
                                    <span
                                    class="badge badge-outline bg-primary me-1">Support</span>
                                    } - <strong class="ms-1 me-1">{{
                                  answer.created_at | date: 'dd.MM.yyyy HH:mm' }}</strong>
                                  @if (answer.merge_source) {
                                    <span class="ms-1 link badge badge-outline bg-cyan"
                                      [routerLink]="['/ticket/view', answer.merge_source]"
                                    [ngbTooltip]="'Diese Antwort wurde aus der zusammengeführten Anfrage übernommen.'">Zusammengeführt</span>
                                  }
                                </div>
                                @if (answer.folded || answer.folded === undefined) {
                                  <div [className]="answer.type === 'customerAnswer' ? 'card-body folded-message' : 'card-body folded-message notpublic'"
                                    [innerHTML]="htmlContent(answer.text)">
                                  </div>
                                }
                                @if (answer.folded === false) {
                                  <div [className]="answer.type === 'customerAnswer' ? 'card-body unfolded-message' : 'card-body unfolded-message notpublic'"
                                  [innerHTML]="htmlContent(answer.text)"></div>
                                }
                                @if (answer.folded || answer.folded === undefined) {
                                  <div class="card-footer card-small">
                                    <a (click)="toggleFold(answer);" class="link">Alles anzeigen</a>
                                  </div>
                                }
                                @if (answer.folded === false) {
                                  <div class="card-footer card-small">
                                    <a (click)="toggleFold(answer);" class="link">Weniger anzeigen</a>
                                  </div>
                                }
                                @if (answer.attachments && answer.attachments.length > 0) {
                                  <div class="card-footer card-small">
                                    @for (attachment of answer.attachments; track attachment) {
                                      <a class="link badge badge-gray me-1 mb-1 attachment-link"
                                        (click)="downloadAttachment(answer._id!, attachment)"
                                        >
                                        <span class="ms-1 v-middle">{{ attachment.filename }} {{ attachment.size | attachmentSize
                                        }}</span>
                                      </a>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                        <div class="col-lg-12">
                          <div class="card">
                            <div class="card-header">
                              <div class="card-title">Neue Antwort schreiben</div>
                            </div>
                            @if (ticket.internal_status === 'merged') {
                              <div class="card-body">
                                <div class="alert alert-warning">
                                  Diese Anfrage wurde vom EFS-IT-Support mit <a
                                [routerLink]="['/ticket', ticket.merged_with_ticket_id]">einer anderen Anfrage</a>
                                zusammengeführt. Bitte antworten Sie dort.
                              </div>
                            </div>
                          }
                          @if (ticket.internal_status !== 'merged') {
                            <div class="card-body">
                              <div class="row row-eq-height">
                                <div class="col-lg-8 mb-4">
                                  @if (config && editor) {
                                    <div class="form-group">
                                      <label class="form-label">Nachricht</label>
                                      <ckeditor [config]="config" [editor]="editor" [(ngModel)]="answerText"></ckeditor>
                                    </div>
                                  }
                                </div>
                                <div class="col-lg-4 text-center center-container mb-2">
                                  <div class="justify-center">
                                    <div class="mb-3">
                                      @if (!isProcessing) {
                                        <label class="form-label"><strong>Nimm eine Sprachmitteilung auf</strong></label>
                                      }
                                      @if (!isProcessing) {
                                        <small>(maximal 5 Minuten)</small>
                                        }<br>
                                        @if (isRecording && !blobUrl) {
                                          <div><h3 class="mb-1">{{recordedTime}}</h3></div>
                                        }
                                        @if (!isRecording && blobUrl && !isProcessing) {
                                          <div>
                                            <audio class="mt-3 mb-2"  controls>
                                              <source [src]="blobUrl" type="audio/mpeg">
                                            </audio>
                                          </div>
                                        }
                                        @if (!isRecording && !blobUrl && !isProcessing) {
                                          <div class="btn btn-efs btn-sm mt-2" (click)="startRecording()">Aufnahme starten</div>
                                        }
                                        @if (!isProcessing && isRecording && !blobUrl) {
                                          <div class="btn btn-efs btn-sm mt-2" (click)="stopRecording()">Aufnahme stoppen</div>
                                        }
                                        @if (!isProcessing && !isRecording && blobUrl) {
                                          <div class="btn btn-efs btn-sm mt-2" (click)="clearRecordedData()">Aufnahme löschen</div>
                                          }<br>
                                          @if (!isProcessing && !isRecording && blobUrl) {
                                            <div class="btn btn-success btn-sm mt-2" (click)="processRecording()">Aufnahme verwenden</div>
                                          }
                                          @if (noTranscriptionFound) {
                                            <div class="ms-3 me-3 alert alert-warning mt-3">
                                              Der Text der Sprachmitteilung konnte nicht automatisch erkannt werden. Die Aufnahme wird dennoch an den EFS-IT-Support übermittelt.
                                            </div>
                                          }
                                          @if (isProcessing) {
                                            <div class="ps-5 pe-5 mt-3">
                                              <h3 class="mb-1">Die Aufnahme wird verarbeitet.</h3>
                                              <small class="mb-3">Einen Moment bitte ...</small><br>
                                              <div class="progress ps-2 pe-2 mt-2">
                                                <div class="progress-bar progress-bar-indeterminate bg-green"></div>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                        <hr>
                                          <div>
                                            <label class="form-label"><strong>Nimm ein Desktop-Video auf</strong></label>
                                            <small>(maximal 5 Minuten)</small><br>
                                            <div class="ms-2 me-2 pt-2"><strong>TIPP:</strong> Wähle nach dem Starten den gesamten<br>Bildschirm für die Aufnahme aus.<br>Damit erhält der EFS-IT-Support die beste Übersicht<br>um dir bei deinem Anliegen zu helfen!</div><br>
                                            @if (isVideoRecording) {
                                              <div><h3 class="mb-1">{{recordedTimeVideo}}</h3></div>
                                            }
                                            @if (!isVideoRecording) {
                                              <div class="btn btn-efs btn-sm mt-2" (click)="startVideoRecording()">Aufnahme starten</div>
                                            }
                                            @if (isVideoRecording) {
                                              <div class="btn btn-efs btn-sm mt-2" (click)="stopVideoRecording()">Aufnahme stoppen</div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-lg-12">
                                        <div class="form-group mt-2">
                                          <label class="form-label">Anhang</label>
                                          <p>
                                            Hier kannst du Bilder, Videos, PDFs und Textdateien hochladen. Die maximale
                                            Größe pro Datei beträgt 100 MB.
                                          </p>
                                          <input type="file" class="form-control" multiple
                                            accept="video/mp4, video/quicktime, message/rfc822, application/pdf, image/*, text/csv, text/plain, text/xml, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, audio/webm"
                                            (change)="fileUploadEvent($event)">
                                          <ul class="mt-3">
                                            @for (attachment of answerFiles; track attachment) {
                                              <div>
                                                @if (attachment.type !== 'audio/webm') {
                                                  <div class="mb-0 mt-1 pb-1"> {{ attachment.name }} <a [ngbTooltip]="'Anhang entfernen'" class="link ms-2" (click)="removeAttachment(attachment)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M4 7l16 0" />
                                                    <path d="M10 11l0 6" />
                                                    <path d="M14 11l0 6" />
                                                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                                  </svg></a>
                                                </div>
                                              }
                                              @if (attachment.type === 'audio/webm') {
                                                <div class="mb-0 mt-1 pb-1" style="line-height: 0px;">
                                                  <audio  controls>
                                                    <source [src]="getBlobUrl(attachment)" type="audio/mpeg">
                                                  </audio>
                                                  <a [ngbTooltip]="'Anhang entfernen'" class="link ms-2" style="vertical-align: super;" (click)="removeAttachment(attachment)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M4 7l16 0" />
                                                    <path d="M10 11l0 6" />
                                                    <path d="M14 11l0 6" />
                                                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                                  </svg></a>
                                                </div>
                                              }
                                            </div>
                                          }
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                              @if (ticket.internal_status !== 'merged') {
                                <div class="card-footer">
                                  @if (isLoading) {
                                    <div class="progress mb-2">
                                      <div class="progress-bar progress-bar-indeterminate bg-green"></div>
                                    </div>
                                  }
                                  <button type="button" class="btn btn-efs {{ isLoading ? 'disabled' : '' }}"
                                  (click)="answerTicket()" [disabled]="isLoading">Antwort senden</button>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }